export default __webpack_public_path__ + "static/4-13288a9ee8599b0ddc7efa6557860433.jpeg";